module.exports = __webpack_public_path__ + "assets/defaultGray-8e35a7.svg";